import styled from 'styled-components';
import Loading from '@whitelabel/component-library/src/components/Loading';

const StyledLoading = styled(Loading)<{ $height?: string }>`
  height: ${({ $height }) => $height || '100vh'};
`;

export default StyledLoading;
